import React from "react";

// Wordmark logo for vonmal — geometric lowercase with an Acid Yellow terminal cursor.
export function Logo({ className = "", size = "text-2xl", withMark = true }) {
  return (
    <span
      data-testid="vonmal-logo"
      className={`font-heading font-black tracking-tighter inline-flex items-baseline gap-[1px] ${size} ${className}`}
    >
      {withMark && <Mark />}
      <span className="text-neon-cyan text-glow-cyan">vonmal</span>
      <span className="text-neon-yellow animate-glow-pulse">_</span>
    </span>
  );
}

// Standalone geometric "v" mark (chevron of speed) used in favicon / nav.
export function Mark({ className = "" }) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      className={`mr-2 self-center ${className}`}
      aria-hidden="true"
    >
      <rect x="1" y="1" width="30" height="30" rx="7" stroke="#00FF9C" strokeWidth="2" />
      <path d="M9 10L16 22L23 10" stroke="#00FF9C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 10L18 10" stroke="#DFFF00" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

export default Logo;
